import { createApp } from 'vue';
import { createHead } from '@unhead/vue/client';
import App from './App.vue';
import { createRouter, createWebHistory } from 'vue-router';
import '../scss/styles.scss';

const defaultTitle = '農研機構 大区画化効果算出アプリ';
const defaultDescription = '大区画化効果算出アプリは対象の農作業とその条件、区画の大きさとを選ぶだけで大区画化による作業能率の改善効果を簡単に試算できるシミュレーションツールです。';

// 基本的なルーティング（後で拡張可能）
const routes = [
  { path: '/', component: () => import('./_pages/Home.vue'), meta: { description: defaultDescription } },
  { path: '/project', component: () => import('./_pages/Project.vue'), meta: { title: '大区画化について', description: 'このページでは大区画化の必要性や課題について説明しています。大区画化効果算出アプリは大区画化による作業効率の改善効果を簡単に試算できるシミュレーションツールです。' } },
  { path: '/about', component: () => import('./_pages/About.vue'), meta: { title: 'アプリについて', description: 'このページではアプリの概要や主な機能、使用条件について説明しています。大区画化効果算出アプリは大区画化による作業効率の改善効果を簡単に試算できるシミュレーションツールです。' } },
  { path: '/guide', component: () => import('./_pages/Guide.vue'), meta: { title: '活用ガイド', description: 'このページではアプリの使い方について説明しています。大区画化効果算出アプリは大区画化による作業効率の改善効果を簡単に試算できるシミュレーションツールです。' } },
  { path: '/faq', component: () => import('./_pages/Faq.vue'), meta: { title: 'FAQ', description: 'このページではよくいただくご質問に対する回答をまとめています。大区画化効果算出アプリは大区画化による作業効率の改善効果を簡単に試算できるシミュレーションツールです。' } },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const head = createHead();
let headEntry = null;

router.afterEach((to) => {
  const title = to.meta.title ? `${to.meta.title} | ${defaultTitle}` : defaultTitle;
  const description = to.meta.description || defaultDescription;

  const url = window.location.href;

  const headData = {
    title,
    meta: [
      { name: 'description', content: description },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:image', content: '/common/images/ogp.png' },
      { property: 'og:url', content: url },
    ],
  };

  if (headEntry) {
    headEntry.patch(headData);
  } else {
    headEntry = head.push(headData);
  }
});

const app = createApp(App);
app.use(head);
app.use(router);
app.mount('#app');
